/** One safety class and an Institution that teaches it (GET api/codelist/training/safety/classdesc, Viewpoint bHRTC).
 * The training API accepts only an Institution from this set (TrainingCreateOrUpdateDtoValidator). */
export interface SafetyClassInstitution {
  ClassDesc: string;
  Institution: string | null;
}
